
module.exports = function() {

  return new Promise(resolve => {
    resolve('foo');
  });
};
